import { BoltIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const tooltipClass =
  "absolute left-1/2 -translate-x-1/2 top-full mt-2 z-10 hidden group-hover:block bg-gray-900 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap";

export default function CreditsBadge({ credits }) {
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 500);
    return () => clearTimeout(timer);
  }, [credits]);

  const getColor = () => {
    if (credits < 100) return "bg-red-600 text-white";
    if (credits < 500) return "bg-amber-400 text-black";
    return "bg-emerald-100 text-emerald-800";
  };

  const getPulse = () => (credits < 100 ? "animate-pulse" : "");

  const getReviewsTooltip = () => {
    if (credits < 100) return "Critically low reviews";
    if (credits < 500) return "Low reviews";
    return `${credits} reviews available`;
  };

  return (
    <span
      className={`
        inline-flex items-center rounded-full shadow-md
        transition-all duration-300 hover:shadow-lg
        ${getColor()}
        ${animate ? "scale-110" : "scale-100"}
        ${getPulse()}
      `}
    >
      {/* Reviews count */}
      <span
        className="relative group inline-flex items-center gap-1 pl-3 pr-2 py-1.5 text-sm font-semibold cursor-default"
        aria-label={getReviewsTooltip()}
      >
        <BoltIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0" />
        {credits}
        <span className={tooltipClass}>{getReviewsTooltip()}</span>
      </span>

      <span aria-hidden="true" className="h-4 w-px bg-current opacity-30" />

      {/* Buy more */}
      <button
        type="button"
        className="relative group inline-flex items-center px-2.5 py-1.5 rounded-r-full hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-1"
        onClick={() => navigate("/dashboard/add-credits")}
        aria-label="Buy more reviews"
      >
        <PlusIcon aria-hidden="true" className="h-4 w-4 flex-shrink-0" />
        <span className={tooltipClass}>Buy more</span>
      </button>
    </span>
  );
}
